import { useEffect, useState } from 'react';
import { notificationsService } from '../../api/notificationsService/notificationsService';
import { INotification } from '../../types/notifications';
import { IsAuthorized } from '../helpers/auth';

export const useNotificationsLoader = () => {
    const [notifications, setNotifications] = useState<INotification[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadNotifications = async () => {
            if (!IsAuthorized()) {
                return;
            }

            setIsLoading(true);
            setError(null);

            try {
                const response = await notificationsService.getNotificationsToRead();
                
                if (response.success) {
                    setNotifications(response.responseBody.notifications || []);
                } else {
                    setError('Failed to load notifications');
                    setNotifications([]);
                }
            } catch (err) {
                setError('Error loading notifications');
                setNotifications([]);
            } finally {
                setIsLoading(false);
            }
        };

        // Carica le notifiche in modo asincrono dopo un breve delay
        // per permettere al resto dell'app di caricarsi prima
        const timer = setTimeout(() => {
            loadNotifications();
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    return {
        notifications,
        isLoading,
        error,
        refetch: () => {
            // Metodo per ricaricare le notifiche se necessario
            const loadNotifications = async () => {
                if (!IsAuthorized()) return;
                
                setIsLoading(true);
                setError(null);

                try {
                    const response = await notificationsService.getNotificationsToRead();
                    
                    if (response.success) {
                        setNotifications(response.responseBody.notifications || []);
                    } else {
                        setError('Failed to load notifications');
                    }
                } catch (err) {
                    setError('Error loading notifications');
                } finally {
                    setIsLoading(false);
                }
            };

            loadNotifications();
        }
    };
}; 